import { render, staticRenderFns } from "./SourcingTagsMultiselect.vue?vue&type=template&id=ec65a4ce"
import script from "./SourcingTagsMultiselect.vue?vue&type=script&lang=js"
export * from "./SourcingTagsMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports